module.exports = __webpack_public_path__ + "img/数据分析.70626b7b.png";